export const KB_AUDIENCES = [
  { value: "everyone", label: "Everyone", short: "Everyone" },
  { value: "agent", label: "Agents", short: "Agents" },
  { value: "reseller", label: "Resellers", short: "Resellers" },
  { value: "master_agent", label: "Master Agents", short: "Master Agents" },
  { value: "service_provider", label: "Service Providers", short: "Service Providers" },
  { value: "referral", label: "Referral partners", short: "Referral" },
  { value: "internal", label: "Internal (staff)", short: "Internal" },
];

export const audienceLabel = (v) => (KB_AUDIENCES.find((a) => a.value === v) || {}).short || v;
export const audienceSummary = (auds) =>
  !auds || !auds.length ? "No audience set" : auds.map(audienceLabel).join(", ");

// Sections are additive to the always-visible main content, so "everyone" is
// not offered at the section level.
export const SECTION_AUDIENCES = KB_AUDIENCES.filter((a) => a.value !== "everyone");
